import React from 'react';

export default function CardHeader({
  title,
  description,
  leftAction,
  rightAction,
  children,
  className = ''
}) {
  return (
    <div className={`bg-gray-900 shadow sm:rounded-lg ${className}`}>
      <div className="border-b border-white/10 px-4 py-5">
        <div className="-ml-4 -mt-2 flex flex-wrap items-end justify-between sm:flex-nowrap">
          <div className="w-full ml-4 mt-2">
            {leftAction ? (
              leftAction
            ) : (
              <>
                {title && (
                  <h3 className="text-base font-semibold leading-6 text-white">
                    {title}
                  </h3>
                )}
                {description && (
                  <p className="mt-1 text-sm text-gray-400">
                    {description}
                  </p>
                )}
              </>
            )}
          </div>
          {rightAction && (
            <div className="ml-4 mt-2 flex-shrink-0">
              {rightAction}
            </div>
          )}
        </div>
      </div>
      {children}
    </div>
  );
}
